import { Router } from '@angular/router';
import { Component, OnInit, EventEmitter, Output, Renderer } from '@angular/core';
import { AsyncLocalStorage } from 'angular-async-local-storage';

import { Block } from '../../../models/block';
import { BlockService } from '../../../services/block.service';
import { Validation } from "../../../config/validation";
import { Input } from '@angular/core/src/metadata/directives';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';

declare var $: any;
declare var JQuery: any;

@Component({
	selector: 'app-block-modal',
	templateUrl: './block-modal.component.html',
	styleUrls: ['./block-modal.component.css'],
	providers: [BlockService]
})
export class BlockModalComponent implements OnInit {
	public title: String;
	public blocks: Array<Block> = [];
	public selectedRow: Number;
	private block: Block;
	private validDateCaducidad;
	private validDateEmision;
	private vl : Validation;
	myForm: FormGroup;
	@Output() sendBlock = new EventEmitter();
	public hoy = new Date().toDateString();
	public loading = false;

	constructor(
		public blockService: BlockService,
		private NavRoute: Router,
		private storage: AsyncLocalStorage,
		private render: Renderer,
		public fb: FormBuilder,
	) {
		this.title = "Blocks";
	}

	ngOnInit() {
		this.vl = new Validation();
		this.block = new Block();
		this.onForm();
		this.getBlocks();
	}

	getBlocks() {
		this.loading = true;
		this.blockService.getAll().subscribe(
			res => {
				this.loading = false;
				if (!res.length) {
					this.blocks = [];
				} else {
					this.blocks = res;
				}
			},	
			err => {
				this.loading = false;
				this.blocks = [];
			}
		);
	}

	onSubmit() {
		//envía de objecto block
		this.setEntityForm();

		this.sendBlock.emit(this.block);
		//Cierre de modal o componente
		$('#block-modal').appendTo('body').modal('toggle');
	}

	onForm(){
		this.myForm = this.fb.group({
			secuencial_inicial: ['', [Validators.required, Validators.pattern(/[0-9]/)]],
			secuencial_fin: ['', [Validators.required, Validators.pattern(/[0-9]/)]],
			fecha_caducidad: [new Date().toISOString().substring(0,10), [Validators.required]],
			fecha_emision: [new Date().toISOString().substring(0,10) , [Validators.required]],
		});
	}

	setEntityForm(){
		this.block.secuencial_inicio = this.myForm.controls["secuencial_inicial"].value;
		this.block.secuencial_fin = this.myForm.controls["secuencial_fin"].value;
		this.block.fecha_emision = this.myForm.controls["fecha_emision"].value;
		this.block.fecha_caducidad = this.myForm.controls["fecha_caducidad"].value;
	}

	//validar fechas cada vez que se digite
	onValidDateEmision() {
		this.block.fecha_emision = this.myForm.controls['fecha_emision'].value;
		this.validDateEmision = this.vl.validDateYYYY(this.block.fecha_emision.toString());
		return this.validDateEmision;
	}
	onValidDateCaducidad() {
		this.block.fecha_caducidad = this.myForm.controls['fecha_caducidad'].value;
		this.validDateCaducidad = this.vl.validDateYYYY(this.block.fecha_caducidad.toString());
		return this.validDateCaducidad;
	}

	validErrorForm(campo){
		return this.vl.validErrorForm(campo,this.myForm);
	}

	validTypeMsgForm(nombre,campo){
		return this.vl.validTypeMsgForm(nombre,campo,this.myForm);
	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/block-modal/block-modal.component.ts